"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardController = function DashboardController() {
  (0, _classCallCheck3.default)(this, DashboardController);
};

// WEBPACK FOOTER //


exports.default = DashboardController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/dashboard/dashboard.controller.js
 **/